import { types as QTypes } from "../components/questionnaire/types";
const defaultOp = {
  id: null,
  title: '标题',
  description: "",
  imgUrl: null,
  publish: "N",
  detail: [],
  max: 100
};
let i18n;
class Questionnaire {
  constructor(options, ext) {
    i18n = ext && ext.i18n;

    defaultOp.title = this._t('quest.k_3001', '标题')

    let _op = Object.assign({}, defaultOp, options);


    _op.detail.forEach(item => {
      // 每个提醒
      if (item.ext) {
        if (typeof item.ext === "object") {
          // 都走这种情况
        } else {
          item.ext = JSON.parse(item.ext);
          item.ext.edit = false;
        }
      }
      // item.detail.length == undefined
      if (item.detail !== null && !(item.detail instanceof Array) && JSON.stringify(item.detail) !== "{}" && item.detail.row) {
        item.detail.row.forEach(item1 => {
          if (item.detail.format === "checkbox") {
            item1.selected = [];
          } else {
            item1.selected = "";
          }
        });
      }
    });
    ({
      id: this.id,
      title: this.title,
      description: this.description,
      imgUrl: this.imgUrl,
      publish: this.publish,
      detail: this.detail,
      max: this.max
    } = _op);
  }
  addQuestion(q) {
    if (this.detail.length < this.max) {
      this.detail.push(q);
    }
  }
  removeQuestion(index) {
    this.detail.splice(index, 1);
  }
  // 获取邮箱数据结构
  getEmail() {
    return {
      title: this._t('quest.k_3002', '邮箱'),
      type: QTypes.TEXT,
      style: QTypes.EMAIL,
      required: "N",
      verification: "Y",
      detail: {
        format: "email",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取年龄数据结构
  getInt() {
    return {
      title: this._t('quest.k_3003', '数字'),
      type: QTypes.TEXT,
      style: "text",
      required: "N",
      detail: {
        format: "integer",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取日期/时间数据结构
  getDate() {
    return {
      title: this._t('quest.k_3004', '日期/时间'),
      type: QTypes.DATE,
      required: "N",
      detail: {
        format: "Y-m-d"
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取城市数据结构
  getCity() {
    return {
      title: this._t('quest.k_3005', '地域'),
      type: QTypes.AREA,
      style: QTypes.AREA,
      required: "N",
      detail: {
        level: "address"
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取单选数据结构
  getRadio() {
    return {
      title: this._t('quest.k_3006', '题目'),
      type: QTypes.RADIO,
      style: "radio",
      required: "N",
      detail: {
        list: [{
          value: this._t('quest.k_3007', '选项'),
          is_answer: 0
        }, {
          value: this._t('quest.k_3007', '选项'),
          is_answer: 0
        }]
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取多选数据结构
  getCheckbox() {
    return {
      title: this._t('quest.k_3006', '题目'),
      type: QTypes.CHECKBOX,
      required: "N",
      detail: {
        list: [{
          value: this._t('quest.k_3007', '选项'),
          is_answer: 0
        }, {
          value: this._t('quest.k_3007', '选项'),
          is_answer: 0
        }],
        min: null,
        max: null
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取下拉数据结构
  getSelect() {
    return {
      title: this._t('quest.k_3006', '题目'),
      type: QTypes.SELECT,
      required: "N",
      detail: {
        list: [{
          value: this._t('quest.k_3007', '选项')
        }, {
          value: this._t('quest.k_3007', '选项')
        }],
        min: null,
        max: null
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  getMultipleSelect() {
    return {
      title: this._t('quest.k_3006', '题目'),
      type: QTypes.CHECKBOX,
      style: QTypes.MULTIPLE_SELECT,
      required: "N",
      detail: {
        list: [{
          value: this._t('quest.k_3007', '选项')
        }, {
          value: this._t('quest.k_3007', '选项')
        }]
      },
      ext: {
        type: "q-select-multiple",
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取问答数据结构
  getQA() {
    return {
      title: this._t('quest.k_3006', '题目'),
      type: QTypes.TEXT,
      style: "text",
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取公司数据结构
  getCompany() {
    return {
      title: this._t('quest.k_3008', '公司'),
      type: QTypes.TEXT,
      style: QTypes.COMPANY,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取职务数据结构
  getPosition() {
    return {
      title: this._t('quest.k_3009', '职务'),
      type: QTypes.TEXT,
      style: QTypes.POSTION,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取姓名数据结构
  getName() {
    return {
      title: this._t('quest.k_3010', '姓名'),
      type: QTypes.TEXT,
      style: QTypes.NAME,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取性别数据结构
  getSex() {
    return {
      title: this._t('quest.k_3011', '性别'),
      type: QTypes.RADIO,
      style: QTypes.SEX,
      required: "N",
      detail: {
        list: [{
          value: this._t('quest.k_3012', '男'),
          is_answer: 0
        }, {
          value: this._t('quest.k_3013', '女'),
          is_answer: 0
        }]
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取手机数据结构
  getPhone() {
    return {
      title: this._t('quest.k_3014', '手机'),
      type: QTypes.TEXT,
      style: QTypes.PHONE,
      required: "Y",
      verification: "Y",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime(),
        type: "phone"
      }
    };
  }
  // 获取地域数据结构
  getAreade() {
    return {
      title: this._t('quest.k_3005', '地域'),
      type: QTypes.TEXT,
      style: QTypes.AREADE,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取生日数据结构
  getBirthday() {
    return {
      title: this._t('quest.k_3015', '生日'),
      type: QTypes.DATE,
      style: QTypes.BIRTHDAY,
      required: "N",
      detail: {
        format: "Y-m-d"
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取行业数据结构
  getIndustry() {
    return {
      title: this._t('quest.k_3016', '行业'),
      type: QTypes.TEXT,
      style: QTypes.INDUSTRY,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取教育水平数据结构
  getEducation() {
    return {
      title: this._t('quest.k_3017', '教育水平'),
      type: QTypes.TEXT,
      style: QTypes.EDUCATION,
      required: "N",
      detail: {
        format: "",
        max: 0
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }

  // 获取单选表格数据结构
  getRadioMatrix() {
    return {
      title: this._t('quest.k_3018', '单选表格'),
      type: QTypes.MATRIX,
      required: "N",
      detail: {
        format: "radio",
        row: [{
          value: this._t('quest.k_3019', '张三丰'),
        }, {
          value: this._t('quest.k_3020', '张无忌'),
        }],
        column: [{
          value: this._t('quest.k_3021', '少侠'),
        }, {
          value: this._t('quest.k_3022', '大侠'),
        }]
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取多选表格
  getCheckboxMatrix() {
    return {
      title: this._t('quest.k_3023', '多选表格'),
      type: QTypes.MATRIX,
      required: "N",
      detail: {
        format: "checkbox",
        row: [{
          value: this._t('quest.k_3019', '张三丰'),
          selected: []
        }, {
          value: this._t('quest.k_3020', '张无忌'),
          selected: []
        }],
        column: [{
          value: this._t('quest.k_3021', '少侠'),
        }, {
          value: this._t('quest.k_3022', '大侠'),
        }]
      },
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取分割线数据结构
  getLine() {
    return {
      title: this._t('quest.k_3024', '分割线'),
      type: QTypes.LINE,
      required: "N",
      detail: {},
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }
  // 获取备注数据结构
  getRemark() {
    return {
      title: this._t('quest.k_3025', '备注描述'),
      type: QTypes.REMARK,
      required: "N",
      detail: {},
      ext: {
        edit: true,
        time: new Date().getTime()
      }
    };
  }

  _t(key, defaultValue) {
    let v;
    if (i18n && key) {
      v = i18n.t(key);
    }
    return !v || v === key ? defaultValue : v;
  }
}
export default Questionnaire;